import {ElementUtil} from '../../utils/elementUtil.js';
import {Service} from '../../service/service.js';
import {TimeUtil} from '../../utils/timeUtil.js';

var VALIDATION_CHECKLIST = [
	{key: 'companySetup', label: 'Company setup reviewed'},
	{key: 'integrationsPending', label: 'Integrations are in pending state'},
	{key: 'usersReviewed', label: 'Users and groups reviewed'},
	{key: 'dataSpotCheck', label: 'Data spot-check completed'},
	{key: 'billingProducts', label: 'Billing is correct with right products'},
	{key: 'usersRoles', label: 'Users and roles verified'},
	{key: 'autoTractors', label: 'Auto tractors, unit filters, and option pipelines checked'},
	{key: 'units', label: 'Tractors, drivers, and trailers verified'},
	{key: 'unitGroups', label: 'Unit groups transferred'},
	{key: 'integrations', label: 'Integrations configured (not started yet)'},
	{key: 'reportHistory', label: 'Report history and scheduled reports verified'},
	{key: 'reportTypes', label: 'Company-specific report types verified'},
	{key: 'closeReportSets', label: 'Close report sets verified'}
];

export function showMigrationStep2Dialog(record, migrationService, onRefresh) {
	var checklistState = {};
	var selectedUser = null;
	var selectedGroup = null;
	var createSsoButton;
	var createLocalButton;
	var usersGrid;
	var groupsGrid;

	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Step 2 - Validation Phase',
		icon: 'vaadin:check-square',
		width: .9,
		height: .85,
		listeners: {
			ready: function() {
				dialog.show();

				// Vertical layout (Details, Users/Roles, Checklist). Tabs were considered but this single-scroll layout works well for validation.
				var contentPanel = ElementUtil.create({
					tag: 'div',
					style: 'overflow: auto; padding-right: 4px;'
				});

				var detailsPanel = ElementUtil.create({
					tag: 'fieldset',
					style: 'margin: 0 0 20px 0; padding: 12px;',
					children: [
						{tag: 'legend', trustedInnerHTML: true, innerHTML: 'Details'},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V6:</strong> ' + (record.v6CompanyName || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>V8:</strong> ' + (record.companyName || '')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>Data range:</strong> '
							+ (record.dataStartDate ? TimeUtil.formatDateStandard(TimeUtil.parseDate(record.dataStartDate)) : 'n/a')
							+ ' to '
							+ (record.dataEndDate ? TimeUtil.formatDateStandard(TimeUtil.parseDate(record.dataEndDate)) : 'n/a')},
						{tag: 'div', trustedInnerHTML: true, innerHTML: '<strong>Note:</strong> ' + (record.note || '')}
					]
				});
				contentPanel.appendChild(detailsPanel);

				usersGrid = ElementUtil.create({
					tag: 'vaadin-grid',
					theme: 'row-stripes column-borders',
					style: 'height: 260px; width: 100%;',
					defaults: {tag: 'vaadin-grid-column', autoWidth: true},
					children: [
						{path: 'username', header: 'Username'},
						{path: 'firstName', header: 'First Name'},
						{path: 'lastName', header: 'Last Name'},
						{path: 'email', header: 'Email'},
						{path: 'phone', header: 'Phone'},
						{path: 'v6Groups', header: 'V6 Groups'},
						{path: 'v8Status', header: 'V8 Status'}
					],
					listeners: {
						'active-item-changed': function(event) {
							selectedUser = event.detail.value || null;
							usersGrid.selectedItems = selectedUser ? [selectedUser] : [];
							updateCreateUserButtons();
						}
					}
				});

				groupsGrid = ElementUtil.create({
					tag: 'vaadin-grid',
					theme: 'row-stripes column-borders',
					style: 'height: 220px; width: 100%;',
					defaults: {tag: 'vaadin-grid-column', autoWidth: true},
					children: [
						{path: 'groupName', header: 'V6 Group'},
						{path: 'groupDescription', header: 'Description'},
						{path: 'userCount', header: 'Users'},
						{path: 'v8Status', header: 'V8 Status'}
					],
					listeners: {
						'active-item-changed': function(event) {
							selectedGroup = event.detail.value || null;
							groupsGrid.selectedItems = selectedGroup ? [selectedGroup] : [];
						}
					}
				});

				var usersRolesPanel = ElementUtil.create({
					tag: 'div',
					children: [
						{
							tag: 'fieldset',
							style: 'margin: 0 0 20px 0; padding: 12px;',
							children: [
								{tag: 'legend', innerHTML: 'Migrate Users'},
								{
									tag: 'div',
									style: 'margin-bottom: 8px;',
									defaults: {tag: 'vaadin-button'},
									children: [
										{
											itemid: 'createSsoUser',
											theme: 'primary',
											disabled: true,
											children: [ElementUtil.makeIcon('vaadin:user', ' Create SSO User')],
											postinit: function(button) {
												createSsoButton = button;
											},
											listeners: {
												click: function() {
													promptCreateUser(true);
												}
											}
										},
										{
											itemid: 'createLocalUser',
											style: 'margin-left: 8px;',
											disabled: true,
											children: [ElementUtil.makeIcon('vaadin:user', ' Create Local User')],
											postinit: function(button) {
												createLocalButton = button;
											},
											listeners: {
												click: function() {
													promptCreateUser(false);
												}
											}
										}
									]
								},
								usersGrid
							]
						},
						{
							tag: 'fieldset',
							style: 'margin: 0 0 20px 0; padding: 12px;',
							children: [
								{tag: 'legend', innerHTML: 'V6.x Company Role'},
								{
									tag: 'div',
									style: 'margin-bottom: 8px;',
									children: [
										{
											tag: 'vaadin-button',
											theme: 'primary',
											children: [ElementUtil.makeIcon('vaadin:plus', ' Add Role')],
											listeners: {
												click: function() {
													showAddRoleDialog(record, selectedGroup, function() {
														reloadGroups();
													});
												}
											}
										}
									]
								},
								groupsGrid
							]
						}
					]
				});
				contentPanel.appendChild(usersRolesPanel);

				function reloadUsers() {
					migrationService.getMigrationUsers(record.migrationId).then(function(result) {
						usersGrid.items = (result.data || []).map(function(user) {
							user.v6Groups = Array.isArray(user.v6Groups) ? user.v6Groups.join(', ') : (user.v6Groups || '');
							return user;
						});
						selectedUser = null;
						usersGrid.activeItem = null;
						usersGrid.selectedItems = [];
						updateCreateUserButtons();
					});
				}

				function reloadGroups() {
					migrationService.getMigrationGroups(record.migrationId).then(function(result) {
						groupsGrid.items = result.data || [];
						selectedGroup = null;
						groupsGrid.activeItem = null;
						groupsGrid.selectedItems = [];
					});
				}

				function updateCreateUserButtons() {
					var canCreate = !!(selectedUser && selectedUser.v8Status !== 'Exists');
					if (createSsoButton) {
						createSsoButton.disabled = !canCreate;
					}
					if (createLocalButton) {
						createLocalButton.disabled = !canCreate;
					}
				}

				function promptCreateUser(ssoUser) {
					if (!selectedUser) {
						window.DL.MessageUtil.showOkMessage('Select a user to create.');
						return;
					}
					var displayName = selectedUser.username
						|| ((selectedUser.firstName || '') + ' ' + (selectedUser.lastName || '')).trim()
						|| selectedUser.email
						|| 'selected user';
					var createType = ssoUser ? 'SSO' : 'Local';
					var confirmMessage = 'Create User ' + displayName + ' as a ' + createType + ' user?';
					if (ssoUser && !isValidEmail(selectedUser.email)) {
						confirmMessage += '<br><br>V6 does not have a valid email for this user. You will need to enter one in the create form.';
					}
					window.DL.MessageUtil.showConfirm({
						title: 'Create ' + createType + ' User',
						message: confirmMessage,
						buttons: [
							{
								text: 'Yes',
								theme: 'primary',
								handler: function() {
									showCreateMigrationUserDialog(record, selectedUser, ssoUser, function() {
										reloadUsers();
									});
								}
							},
							{
								text: 'No',
								theme: 'tertiary'
							}
						]
					});
				}

				reloadUsers();
				reloadGroups();

				var savedChecklist = {};
				if (record.validationChecklistJson) {
					try {
						savedChecklist = JSON.parse(record.validationChecklistJson) || {};
					} catch (parseError) {
						savedChecklist = {};
					}
				}
				VALIDATION_CHECKLIST.forEach(function(item) {
					checklistState[item.key] = !!savedChecklist[item.key];
				});

				var completeValidationButton;

				function buildChecklistPayload() {
					var checklist = {};
					VALIDATION_CHECKLIST.forEach(function(item) {
						checklist[item.key] = !!checklistState[item.key];
					});
					return {checklist: checklist};
				}

				function updateCompleteButton() {
					var allChecked = VALIDATION_CHECKLIST.every(function(item) {
						return checklistState[item.key];
					});
					if (completeValidationButton) {
						completeValidationButton.disabled = !allChecked;
					}
				}

				var checklistChildren = [
					{tag: 'legend', innerHTML: 'Manual Review Checklist (Check when Completed)'}
				].concat(VALIDATION_CHECKLIST.map(function(item) {
					return {
						tag: 'vaadin-checkbox',
						label: item.label,
						style: 'display: block; margin-bottom: 8px;',
						properties: {
							checked: !!checklistState[item.key]
						},
						listeners: {
							change: function(event) {
								checklistState[item.key] = event.target.checked;
								updateCompleteButton();
							}
						}
					};
				}));
				checklistChildren.push({
					tag: 'div',
					style: 'margin-top: 8px;',
					children: [
						{
							tag: 'vaadin-button',
							theme: 'primary',
							children: [ElementUtil.makeIcon('vaadin:database', ' Save Progress')],
							listeners: {
								click: function() {
									migrationService.saveValidationChecklist(
										record.migrationId,
										buildChecklistPayload()
									).then(function(result) {
										var updated = result.data || result;
										if (updated && updated.validationChecklistJson) {
											record.validationChecklistJson = updated.validationChecklistJson;
										}
										window.DL.MessageUtil.showToast('Success', 'Review progress saved', {
											theme: 'success'
										});
										if (onRefresh) {
											onRefresh();
										}
									});
								}
							}
						}
					]
				});

				var checklistPanel = ElementUtil.create({
					tag: 'fieldset',
					style: 'margin: 0 0 12px 0; padding: 12px;',
					children: checklistChildren
				});
				contentPanel.appendChild(checklistPanel);

				var buttonBar = ElementUtil.create({
					tag: 'div',
					style: 'margin-top: 16px; text-align: center;',
					defaults: {tag: 'vaadin-button'},
					children: [
						{
							itemid: 'completeValidation',
							theme: 'primary',
							disabled: true,
							children: [ElementUtil.makeIcon('vaadin:check', ' Complete Validation')],
							postinit: function(button) {
								completeValidationButton = button;
								updateCompleteButton();
							},
							listeners: {
								click: function() {
									migrationService.markValidationComplete(
										record.migrationId,
										buildChecklistPayload()
									).then(function() {
										window.DL.MessageUtil.showToast('Success', 'Validation complete', {theme: 'success'});
										dialog.close();
										if (onRefresh) {
											onRefresh();
										}
									});
								}
							}
						},
						{
							theme: 'tertiary',
							style: 'margin-left: 10px;',
							innerHTML: 'Close',
							listeners: {
								click: function() {
									dialog.close();
								}
							}
						}
					]
				});

				dialog.addToContentElement(contentPanel);
				dialog.addToContentElement(buttonBar);
			}
		}
	});
}

function isValidEmail(value) {
	if (!value || typeof value !== 'string') {
		return false;
	}
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

function showCreateMigrationUserDialog(record, migrationUser, ssoUser, onCreated) {
	var companyId = record.companyId;
	if (!companyId) {
		window.DL.MessageUtil.showOkMessage('V8 company is required before creating users.');
		return;
	}

	var v6Email = isValidEmail(migrationUser.email) ? migrationUser.email.trim() : '';
	var missingV6Email = ssoUser && !v6Email;

	var addWin = ElementUtil.create({
		tag: 'dl-dialog',
		title: (ssoUser ? 'Create SSO User' : 'Create Local User') + ' - ' + (migrationUser.username || ''),
		icon: 'vaadin:plus',
		width: 520,
		height: ssoUser ? (missingV6Email ? 480 : 440) : 520,
		listeners: {
			ready: function() {
				addWin.show();

				var roleComboConfig = {
					tag: 'vaadin-combo-box',
					itemid: 'roleId',
					label: 'Role',
					name: 'roleId',
					'item-value-path': 'roleId',
					'item-label-path': 'roleName',
					required: true,
					placeHolder: 'Select',
					postinit: function(combo) {
						Service.getSecurityService().getSecurityRoles(companyId).then(function(data) {
							combo.items = data || [];
						});
					}
				};

				var securityChildren = ssoUser
					? [
						{
							tag: 'vaadin-email-field',
							itemid: 'userId',
							name: 'userId',
							label: 'SSO User Name (Email Address)',
							required: true,
							maxlength: 120
						},
						roleComboConfig
					]
					: [
						{
							tag: 'vaadin-text-field',
							itemid: 'userId',
							name: 'userId',
							label: 'User Name',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-password-field',
							name: 'password',
							label: 'Password',
							autocomplete: 'new-password',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-password-field',
							name: 'confirmPassword',
							label: 'Confirm Password',
							autocomplete: 'new-password',
							required: true,
							maxlength: 120
						},
						roleComboConfig
					];

				var formChildren = [];
				if (missingV6Email) {
					formChildren.push({
						tag: 'div',
						style: 'margin-bottom: 12px; color: #b45309;',
						innerHTML: 'V6 does not have a valid email for this user. Enter a valid email below to create the SSO user.'
					});
				}

				formChildren.push({
					tag: 'vaadin-form-layout',
					children: [
						{
							tag: 'vaadin-text-field',
							name: 'firstname',
							label: 'First Name',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-text-field',
							name: 'lastname',
							label: 'Last Name',
							required: true,
							maxlength: 120
						},
						{
							tag: 'vaadin-email-field',
							itemid: 'email',
							name: 'email',
							label: 'Email',
							required: true,
							maxlength: 120,
							listeners: ssoUser
								? {
									change: function(event) {
										var emailValue = (event.target.value || '').trim();
										var userIdField = ElementUtil.query(formPanel, 'userId');
										if (userIdField && (!userIdField.value || userIdField.value === v6Email)) {
											userIdField.value = emailValue;
										}
									}
								}
								: undefined
						},
						{
							tag: 'vaadin-text-field',
							name: 'phone',
							label: 'Phone',
							maxlength: 120
						}
					].concat(securityChildren)
				});

				formChildren.push({
					tag: 'div',
					style: 'text-align: center; margin-top: 16px;',
					defaults: {tag: 'vaadin-button'},
					children: [
						{
							theme: 'primary',
							children: [ElementUtil.makeIcon('vaadin:database', ' Save')],
							listeners: {
								click: function() {
									var formData = formPanel.getData();
									if (ssoUser) {
										if (!isValidEmail(formData.email)) {
											window.DL.MessageUtil.showOkMessage('A valid email is required to create an SSO user.');
											return;
										}
										if (!isValidEmail(formData.userId)) {
											window.DL.MessageUtil.showOkMessage('SSO User Name must be a valid email address.');
											return;
										}
									}
									if (!ssoUser && formData.password !== formData.confirmPassword) {
										window.DL.MessageUtil.showOkMessage('Password and Confirm Password must match.');
										return;
									}
									formPanel.submitForm({
										preSubmit: function(data) {
											var userId = (data.userId || '').toLowerCase();
											var email = (data.email || '').trim();
											if (ssoUser && !email) {
												email = userId;
											}
											var newUserModel = {
												securityUser: {
													userId: userId,
													password: data.password
												},
												userProfile: {
													userId: userId,
													firstname: data.firstname,
													lastname: data.lastname,
													email: email,
													phone: data.phone
												},
												ssoUser: !!ssoUser,
												companies: [
													{
														primaryCompany: true,
														securityCompanyUserPk: {
															companyId: companyId,
															userId: userId
														}
													}
												],
												roleMap: {}
											};
											newUserModel.roleMap[companyId] = data.roleId ? [data.roleId] : [];
											return newUserModel;
										},
										actualCall: function(data) {
											return Service.getUserService().addNewUser(data);
										},
										success: function() {
											window.DL.MessageUtil.showToast('Success', 'Created user', {
												theme: 'success',
												position: 'top-stretch'
											});
											addWin.close();
											if (onCreated) {
												onCreated();
											}
										}
									});
								}
							}
						},
						{
							theme: 'tertiary',
							style: 'margin-left: 10px;',
							innerHTML: 'Cancel',
							listeners: {
								click: function() {
									addWin.close();
								}
							}
						}
					]
				});

				var formPanel = ElementUtil.create({
					tag: 'dl-form-panel',
					children: formChildren
				});
				addWin.addToContentElement(formPanel);
				formPanel.load({
					firstname: migrationUser.firstName || '',
					lastname: migrationUser.lastName || '',
					email: v6Email,
					phone: migrationUser.phone || '',
					userId: ssoUser ? v6Email : (migrationUser.username || '')
				});
			}
		}
	});
}

function showAddRoleDialog(record, selectedGroup, onSaved) {
	var companyId = record.companyId;
	if (!companyId) {
		window.DL.MessageUtil.showOkMessage('V8 company is required before creating roles.');
		return;
	}

	var addEditWin = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Add Role',
		icon: 'vaadin:plus',
		width: 480,
		height: 280,
		listeners: {
			ready: function() {
				addEditWin.show();

				var roleForm = ElementUtil.create({
					tag: 'dl-form-panel',
					children: [
						{
							tag: 'vaadin-form-layout',
							children: [
								{
									tag: 'vaadin-text-field',
									label: 'Name',
									name: 'roleName',
									required: true,
									maxlength: 255
								},
								{
									tag: 'vaadin-text-field',
									label: 'Description',
									name: 'roleDescription',
									required: true,
									maxlength: 255
								}
							]
						},
						{
							tag: 'div',
							style: 'text-align: center; margin-top: 16px;',
							defaults: {tag: 'vaadin-button'},
							children: [
								{
									theme: 'primary',
									children: [ElementUtil.makeIcon('vaadin:database', ' Save')],
									listeners: {
										click: function() {
											roleForm.submitForm({
												preSubmit: function(data) {
													return {
														securityRole: {
															companyId: companyId,
															roleName: data.roleName,
															roleDescription: data.roleDescription || data.roleName
														},
														permissions: []
													};
												},
												actualCall: function(data) {
													return Service.getSecurityService().saveSecurityRole(data);
												},
												success: function() {
													window.DL.MessageUtil.showToast('Success', 'Added Role', {
														theme: 'success',
														position: 'top-stretch'
													});
													addEditWin.close();
													if (onSaved) {
														onSaved();
													}
												}
											});
										}
									}
								},
								{
									theme: 'tertiary',
									style: 'margin-left: 10px;',
									innerHTML: 'Cancel',
									listeners: {
										click: function() {
											addEditWin.close();
										}
									}
								}
							]
						}
					]
				});
				addEditWin.addToContentElement(roleForm);
				roleForm.load({
					roleName: selectedGroup && selectedGroup.groupName ? selectedGroup.groupName : '',
					roleDescription: selectedGroup && selectedGroup.groupDescription
						? selectedGroup.groupDescription
						: (selectedGroup && selectedGroup.groupName ? selectedGroup.groupName : '')
				});
			}
		}
	});
}
